// hooks/useModalState.js
import { useState, useEffect } from 'react';

export const useModalState = () => {
    const [modalState, setModalState] = useState('closed');
    const [currentStep, setCurrentStep] = useState(0);
    const [stepperKey, setStepperKey] = useState(Date.now());
    const [activeMenu, setActiveMenu] = useState(null);

    // Chiudi il menu quando si clicca fuori
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (activeMenu && !event.target.closest('.menu-container')) {
                setActiveMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [activeMenu]);

    return {
        modalState,
        setModalState,
        currentStep,
        setCurrentStep,
        stepperKey,
        setStepperKey,
        activeMenu,
        setActiveMenu
    };
};